export default "__VITE_ASSET__CSycG$qb__"